// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"157":"de888daaaa7e87171a8c","192":"40b78a56cda19946c9cd","336":"4b44b44aa046095c5c75","538":"de888daaaa7e87171a8c","607":"0db7b37c15d326d5889f"}[chunkId] + ".min.js";
};